import { CurrencyEnumType } from "@ifgengineering/client-invest-sdk";

export const CURRENCY_SYMBOL: Record<CurrencyEnumType, string> = {
  GBP: "£",
  USD: "$",
};

/**
 * Two decimals so 7.75% is not rounded to 7.8%, trailing zeros trimmed so 7%
 * stays 7% — matches the server's readableRate and the mobile formatter.
 */
export const ratePercent = (rate: number): string =>
  `${parseFloat((rate * 100).toFixed(2))}%`;

export const formatCurrencyWhole = (
  amount: number,
  currency: CurrencyEnumType
): string =>
  `${CURRENCY_SYMBOL[currency] ?? CURRENCY_SYMBOL.GBP}${Math.round(
    amount
  ).toLocaleString("en-GB")}`;

/** e.g. "3 Sep" */
export const formatShortDate = (
  value?: string | null
): string | undefined => {
  if (!value) return undefined;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return undefined;
  return date.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
};
